<template>
	<a-row class="mt-3">
		<div class="air__utils__heading">
			<h5>Last 12 months</h5>
		</div>
		<a-col :span="24">
			<div class="font-weight-bold text-dark font-size-18 text-nowrap">
				Posts
			</div>
			<calendar-heatmap
				:range-color="['#ebedf0', '#c0ddf9', '#73b3f3', '#3886e1', '#17459e']"
				:values="getDetailActivityPosts"
				:end-date="new Date()"
			/>
		</a-col>
		<a-col class="mt-5" :span="24">
			<div class="font-weight-bold text-dark font-size-18 text-nowrap">
				Stories
			</div>
			<calendar-heatmap
				:range-color="['#ebedf0', '#8AFF8A', '#00D100', '#00A300', '#007500']"
				:values="getDetailActivityStories"
				:end-date="new Date()"
			/>
		</a-col>
	</a-row>
</template>

<script>
import * as ACTIONS from '@/store/actions'
import { mapGetters, mapActions } from 'vuex'

export default {
	name: 'DetailActivity',

	props: {
		detailId: {
			type: Number,
			required: true,
		},
	},
	data: function() {
		return {
			chart: {
				chart: {
					type: 'heatmap',
					animations: {
						enabled: false,
					},
					toolbar: {
						show: false,
					},
					zoom: {
						enabled: false,
					},
				},
				dataLabels: {
					enabled: false,
				},
				colors: ['#F08FFB'],
				title: {
					show: false,
				},
			},
		}
	},
	created() {
		this.loadActivity({ id: this.detailId })
	},
	methods: {
		...mapActions({
			loadActivity: ACTIONS.DETAIL.ACTIVITY,
		}),
	},
	computed: {
		...mapGetters(['getDetailActivityPosts', 'getDetailActivityStories']),
	},
}
</script>
